import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';
import { PersonService } from '../service/person.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'a-yoyaku-memo-modal-app',
  templateUrl: './a-yoyaku-memo-modal.component.html',
  styleUrls: ['a-yoyaku-memo-modal.component.css']
})

export class AYoyakuMemoModalComponent {
  @Input() yoyaku_data: any[];
  yoyaku_memo: string = "";

  constructor(
    public commonService: CommonService,
    private personService: PersonService,
    public activeModal: NgbActiveModal,
  ) { }

  ret: any = {
    status: "",
    yoyaku_memo:""
  }

  //起動時処理
  ngOnInit(): void {
    //モーダル内セレクトボックスの初期値設定
    this.ret.yoyaku_memo = this.yoyaku_data['yoyaku_memo'];
  };
  //OK押下時、メモを保存する
  modalCloseOK() {

    this.ret.status = 'OK';
    this.activeModal.close(this.ret);
  }
  //キャンセル時
  modalCloseCancel() {
    this.ret.status = 'Cancel';
    this.activeModal.close(this.ret);
  }
}




// WEBPACK FOOTER //
// ./src/app/a0108-person/a-yoyaku-memo-modal.component.ts